export default __webpack_public_path__ + "static/media/play-circle-fill.38ee5a44.svg";